export const computerTypeInSortOrder = ['Server', 'Arbeidsstasjon', 'mobile'];
